import type { ApiConfig } from '@api/types';
import { typedMethodPost } from '@api/utils';
import type { AcquireStorageAccessRequestDto, AcquireStorageAccessResponseDto } from '@api/generated/models';
import type { StorageAccessResponse } from '@api/domain/types';
import { toStorageAccessResponse } from '@api/domain/mappers';

export default ({ baseURL }: ApiConfig) => ({
  get: typedMethodPost<AcquireStorageAccessRequestDto, AcquireStorageAccessResponseDto, StorageAccessResponse>(
    (data) =>
      fetch(`${baseURL}/v1/feed/getSharedAccessSignature`, {
        method: 'POST',
        ...data,
      }),
    toStorageAccessResponse
  ),
});

// Re-export domain types for consumers
export type { StorageAccessResponse } from '../../domain/types';

// Re-export request DTOs (still needed for building requests)
export type { AcquireStorageAccessRequestDto } from '../../generated/models';
